<template>
  <div>
    <v-container fluid class="white elevation-3 margen d-flex justify-space-between">
      <v-row class="d-flex justify-space-between">
        <v-col cols="12" sm="12" md="3" class="my-auto d-flex">
          <v-btn small text class="mt-3 mx-3 grey lighten-2" to="/Dashboard">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <h1>Proyectos activos</h1>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid class="mt-3 pa-2 white margen">
      <div class="d-flex justify-space-between">
        <div class="d-flex">
          <span class="text-h5 mx-3">Información.</span>
        </div>
      </div>

      <!-- <v-card :disabled="editar" class="ma-3 pa-3"> -->
      <v-card :disabled="false" class="ma-3 pa-3">
        <v-divider></v-divider>

        <!-- SECCION ORDENES -->
        <div class="my-2">
          <div class="text-h6 mx-3 d-flex justify-center ma-1">
            <!-- <span class="mouse noselect" v-ripple @click="mostrarProyectos = !mostrarProyectos" >
              Proyectos activos
              <v-icon dense light>
                {{ iconoFlecha }}
              </v-icon>
            </span> -->
          </div>

          <v-alert v-if="cargandoCheck" class="yellow lighten-3 d-flex justify-center">
            <span class="text--white">Cargando...</span>
          </v-alert>

          <transition name="fade">
            <v-expansion-panels accordion v-if="mostrarProyectos" class="elevation-1 justify-start" focusable multiple>
              <v-card-title style="width: 100%" class="grey lighten-1">
              </v-card-title>

              <div></div>

              <v-expansion-panel v-for="proyecto in proyectos" :key="proyecto.PROYECTO_ID">
                <v-expansion-panel-header expand-icon="mdi-menu-down" class="d-flex">
                  <v-row>
                    <v-col cols="6" xs="6" md="3" class="font-weight-bold">{{proyecto.FOLIO}}</v-col>
                    <v-col cols="6" xs="6" md="3" class="font-weight-bold" style="text-align: right">Productos del proyecto</v-col>
                  </v-row>
                </v-expansion-panel-header>

                <v-expansion-panel-content class="borde">
                  <v-expansion-panel v-for="producto in proyecto.PRODUCTOS" :key="producto.PRODUCTO_ID">
                    <v-expansion-panel-header expand-icon="mdi-menu-down" class="d-flex" >
                      <v-row>
                        <v-col cols="6" xs="6" md="3" class="font-weight-bold">{{ producto.CLAVE_MSP }}</v-col>
                        <v-col cols="6" xs="6" md="3" class="font-weight-bold">{{ producto.NOMBRE }}</v-col>
                        <v-col cols="6" xs="6" md="3" class="font-weight-bold" style="text-align: right">Tareas del producto</v-col>
                      </v-row>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content class="borde">
                      <!-- {{articulosSeleccionados}} -->
                      <v-data-table :key="producto.PRODUCTO_ID"
                        :headers="columnasTareas"
                        :items="producto.TAREAS"
                        show-select
                        
                        selectable-key="REALIZADA"
                        item-key="PRODUCTO_TAREAS_ID"
                        v-model="tareasSeleccionadas"
                        :item-class="deshabilitar_tarea"
                        @input="log"
                        hide-default-footer
                        disable-pagination
                      >
                        <template v-slot:[`header.data-table-select`]></template>

                        <!-- <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
                          <v-simple-checkbox
                            :value="isSelected"
                            :readonly="item.disabled"
                            :disabled="item.disabled"
                            @input="select($event)"
                          ></v-simple-checkbox>
                        </template> -->

                        <template slot="no-data">
                          <v-alert class="my-2" :value="true" type="info" color="orange lighten-2" >No se encontró información para mostrar.</v-alert>
                        </template>

                      </v-data-table>

                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </transition>
        </div>
        <!-- FIN SECCION PRODUCTOS -->

        <v-divider></v-divider>

        <div class="d-flex justify-center mb-2">
          <v-btn class="mx-3 colorP darken-1" dark small text :loading="cargandoCheck" @click="GuardarCambios">
            Guardar Cambios
          </v-btn>
        </div>

      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      //Datos para almacenar los proveedores y sus artículos
      proyectos: [],
      //proveedoresUnicos:[],
      //proveedoresSeleccionados:[],
      tareasSeleccionadas: [],
      mostrarProyectos: false,
      mostrarSnackbar: false,
      mensajeSnack: "",
      colorSnack: "",
      cargandoCheck: false,
      modalFecha: false,
      columnasTareas: [
        { text: "Nombre", value: "DESCRIPCION" },
        { text: "REALIZADA", value: "REALIZADA" },
      ],
    };
  },
  computed: {
    ...mapGetters(["getURLAPI", "getUsuario", "getFechaActual"]),

    iconoFlecha: function () {
      return this.mostrarProyectos
        ? "mdi-arrow-up-drop-circle"
        : "mdi-arrow-down-drop-circle";
    },

  //   tareasS() {
  //   return this.proyectos.map(x => ({ ...x, isSelectable: x.PRODUCTOS.TAREAS.REALIZADAS == 'S' }));
  // }
  },
  methods: {
    async getProyectos() {
      this.cargandoCheck = true;
      //let cont = 1;
      try {
        this.proyectos = (await axios.get(`${this.getURLAPI}/Proyecto/obtenerProyectos`)).data;
        // console.log(this.proyectos);

        for (const proyecto of this.proyectos) {
          axios.get(`${this.getURLAPI}/Proyecto/getProductosProyecto/${proyecto.PROYECTO_ID}`)
            .then(({ data }) => {
              proyecto.PRODUCTOS = data;

              proyecto.PRODUCTOS.forEach( ( element ) => {
                let datosForm = new FormData();
                datosForm.append("PROYECTO_ID", proyecto.PROYECTO_ID);
                datosForm.append("PRODUCTO_ID", element.PRODUCTO_ID);

                // console.log("proyecto: " + proyecto.PROYECTO_ID + " PRODUCTO: " + element.PRODUCTO_ID);

                axios.get(`${this.getURLAPI}/Proyecto/getTareasProducto/${proyecto.PROYECTO_ID}/${element.PRODUCTO_ID}`)
                  .then(({ data }) => {
                    this.$set(element, "TAREAS", data);
                    // element.TAREAS = data;
                    
                    setTimeout( () => {
                      this.cargandoCheck = false;
  
                      this.mostrarProyectos = true;

                    }, 1000);

                  });

              });
            });
        }
        // console.log(this.proyectos);
        // this.mostrarProyectos = true;
      } catch (err) {
        this.cargandoCheck = false;
        console.log(err);
      }
    },
    snackbar(data) {
      this.mostrarSnackbar = true;
      this.mensajeSnack = data.MSG;

      if (data.STATUS !== "ERROR") {
        this.colorSnack = "success darken-1";
      } else {
        this.colorSnack = "red lighten-1";
      }
    },

    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },

    GuardarCambios() {
      this.cargandoCheck = true;
      //console.log(this.proyectos);

      let datosForm = new FormData();
      datosForm.append("TAREAS_REALIZADAS", JSON.stringify(this.tareasSeleccionadas));

      axios.post(`${this.getURLAPI}/Proyecto/guardarTareasRealizadas`, datosForm)
        .then(({ data }) => {
          //console.log(data);
          this.getProyectos();
          this.$root.vtoast.show({
            message: data.MSG,
            color: data.STATUS == "OK" ? "success darken-2" : "red darken-2",
            timer: 10000,
            icon:
              data.STATUS == "OK" ? "mdi-check" : "mdi-alert-circle-outline",
          });
        })
        .catch(() => {
          this.cargandoCheck = false;
          this.$root.vtoast.show({
            message: "Error con el servidor",
            color: "red darken-2",
            timer: 10000,
            icon: "mdi-alert-circle-outline",
          });
        });
      this.cargandoCheck = false;
    },

    log() {
      console.log(this.tareasSeleccionadas);
    },

    deshabilitar_tarea(item){
      return item.REALIZADA == 'S' ? 'deshabilitar desabilitarCheckbox style-1' : '';
    },
  },

  created() {
    document.title = "Chequeo de tareas.";
    //this.minFecha = this.getFechaActual.split(" ");
    this.getProyectos();
  },
};
</script>

<style>

.deshabilitar{
  user-select:none;
  -moz-user-select: none;
  -ms-user-select: none;
  pointer-events: none;
  /* display:none; */
}

.desabilitarCheckbox > td:first-child{
  opacity: 0;
}
</style>
